export const contactsSliceName = 'contacts'
